import authentication from "@/store/modules/authentication";

export default {
  authentication,
};
